import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import type { Dispatch, SetStateAction } from 'react';
import type { Breakdowns } from '~/routes/build-pack/create';
import { getFormattedPrice } from '~/utils/common';

export default function PriceBreakdown({
  quantity,
  isFetchingPrice,
  breakdowns,
  open,
  setOpen,
  onChangeQuantity,
}: {
  quantity: number;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  isFetchingPrice: boolean;
  breakdowns: Breakdowns;
  onChangeQuantity: (value: string) => void;
}) {
  return (
    <>
      {/* Price breakdown button */}
      <Box
        display="flex"
        justifyContent="space-between"
        pl={1.25}
        pr={2}
        py={1.25}
        alignItems="center"
        width="100%"
        borderRadius="8px 8px 0px 0px"
        bgcolor="#F0F5F9"
      >
        <Typography variant="caption" fontWeight="medium">
          Price Breakdown
        </Typography>

        <IconButton onClick={() => setOpen((prev) => !prev)} sx={{ p: 0 }}>
          <ExpandMoreIcon sx={{ transform: `rotate(${open ? '-180deg' : 0})`, transition: 'transform 350ms ease' }} />
        </IconButton>
      </Box>
      {/* Price Breakdown content when open*/}
      <Box
        sx={[
          {
            maxHeight: 0,
            backgroundColor: '#FAFAFA',
            transition: 'max-height 0.3s',
            overflow: 'hidden',
          },
          open && { maxHeight: 62 },
        ]}
      >
        <Box gap={1} pb={3} px={1} borderRadius="0px 0px 8px 8px">
          <Box display="flex" justifyContent="space-around">
            {[50, 100, 150, 200].map((q: number) => (
              <Button
                key={q}
                onClick={() => onChangeQuantity(q.toString())}
                sx={{
                  borderRadius: 2,
                  color: 'text.primary',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  height: '62px',
                  py: 2,
                  backgroundColor: q === quantity ? '#F1F5F9' : 'none',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 700,
                  }}
                  margin={0}
                >
                  {q}
                </Typography>
                <Typography variant="body2" color="primary.light" sx={[isFetchingPrice && { color: 'text.disabled' }]}>
                  {getFormattedPrice(breakdowns[q].pack_price.amount / 100)}
                </Typography>
              </Button>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
}
